export default __webpack_public_path__ + "static/media/LEVEL12.ef846a68.png";